<template>
	<div :class="{'c-poly-upload-input': input, 'flex': input}" :warn="input && !!name && warnState" @click.stop="developHandle" @mouseenter="active = true" @mouseleave="active = false">
		<div v-show="!input || windowPosition" ref="window" :class="{'c-poly-upload-window': input}" :style="windowPosition" @mouseenter="active = true" @mouseleave="active = false">
			<div class="c-poly-upload" :title="fileTypeTip">
				<div class="flex-center">
					<div ref="upload" class="c-poly-upload-main flex-center flex-grow" :class="{'z-active': focusState || dragState}" :warn="!input && !!name && warnState" :style="{'height': bigger ? '120px' : '', 'background': bigger ? '#fff' : ''}" @click="focusHandle">
						<p v-if="focusState">Ctrl+v 粘贴文件，{{fileTypeTip}}</p>
						<template v-else>
							<c-link color="main" style="line-height: 25px;" @click.native.stop="uploadHandle()">点击选择</c-link>
							<p class="ellipsis">拖拽或单击后粘贴文件，{{fileTypeTip}}</p>
						</template>
					</div>
				</div>
						
				<ul v-show="parseValueData.length" class="c-poly-upload-list">
					<li v-for="(item, i) in parseValueData" :key="i" class="flex-center-cross">
						<c-file class="ellipsis" :src="item"></c-file>
						<a class="tf-trash" @click="removeHandle(i)"></a>
					</li>
				</ul>
			</div>
		</div>

		<template v-if="input">
			<div class="c-poly-upload-input-list flex-grow ellipsis">
				<c-file v-for="(item, i) in parseValueData" :key="i" class="ellipsis" :src="item" media :preview="false"></c-file>
			</div>
			<span class="c-poly-upload-input-icon flex-center">
				<i class="tf-upload"></i>
			</span>
		</template>
	</div>
</template>

<script>
	import {getStore, mapStore, getScrollParent} from '@deanwu/vue-component-library'

	export default {
		name: 'cUploadFile',

		props: {
			value: {
				type: [String, Array],
				default: ''
			},

			input: Boolean,
			
			name: String,
			
			type: String,
			
			size: [String, Number],
			
			multiple: {
				type: [Boolean, Number, String],
				default: false
			},

			bigger: Boolean,
			folder: String
		},

		data() {
			return {
				...getStore(this, 'cFormStore'),
				...getStore(this, 'cFormItemStore'),
				valueData: this.multiple ? [] : '',

				active: false,
				focusState: false,
				dragState: false,
				windowPosition: false
			}
		},

		computed: {
			...mapStore('cFormItemStore', ['warnState']),

			parseValueData: {
				get() {
					return this.valueData ? (typeof this.valueData == 'object' ? this.valueData : this.valueData.toString().split(',')) : []
				},
				
				set(val) {
					if (this.multiple) {
						this.valueData = val.join(',').split(',');
					}
				}
			},
			
			fileTypeTip() {
				let arr = [this.$t('_t.upload.type.any')];
				if (this.type) {
					arr = [];
					this.type.split(',').forEach(item => {
						arr = arr.concat(this.$compsConfig.config.file.acceptTip[item] || [item])
					});
				}
				return this.$t('_t.upload.tip', {type: arr.map(item => this.$t(item)).join('、')});
			},

			upperLimit() {
				return this.multiple
					? typeof this.multiple != 'boolean' && this.parseValueData.length >= parseInt(this.multiple)
					: this.parseValueData.length > 0;
			}
		},

		watch: {
			value(val) {
				this.set(val);
			},
			
			valueData() {
				this.$emit('input', this.get());
			}
		},
		
		mounted() {
			this.set(this.value);

			this.$refs.upload.addEventListener('dragenter', e => {
				e.preventDefault();
				this.dragState = true;
			});
			this.$refs.upload.addEventListener('dragover', e => {
				e.preventDefault();
				this.dragState = true;
			});
			this.$refs.upload.addEventListener('dragleave', e => {
				e.preventDefault();
				this.dragState = false;
			});
			this.$refs.upload.addEventListener('drop', e => {
				e.preventDefault();
				this.dragState = false;
				this.uploadHandle(e.dataTransfer.files);
			});

			if (this.input) {
				document.body.appendChild(this.$refs.window);
			}
		},
		
		beforeDestroy() {
			if (this.input) {
				document.body.removeChild(this.$refs.window);
			}
			window.removeEventListener('click', this.blurHandle, true);
			document.removeEventListener('paste', this.pasteHandle);
		},
		
		methods: {
			set(val) {
				if (!val) val = this.multiple ? [] : '';
				if (this.multiple && typeof val == 'string') {
					val = val.split(',');
				}
				this.valueData = val;
				if (Array.isArray(this.valueData)) {
					this.valueData.length && this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				} else {
					this.valueData && this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				}
			},
			
			get() {
				return this.valueData;
			},
			
			developHandle() {
				if (!this.input) return;
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				if (this.windowPosition) return;
				window.addEventListener('click', this.foldHandle, true);
				this.windowPosition = true;
				this.$nextTick(this.updatePosition);
				getScrollParent(this.$el, dom => {
					dom.addEventListener('scroll', this.updatePosition);
				});
			},
			
			foldHandle(e) {
				if (!this.input || this.active) return;
				window.removeEventListener('click', this.foldHandle, true);
				this.windowPosition = false;
				getScrollParent(this.$el, dom => {
					dom.removeEventListener('scroll', this.updatePosition);
				});
			},

			focusHandle() {
				if (this.focusState) return;
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);
				this.focusState = true;
				window.addEventListener('click', this.blurHandle, true);
				document.addEventListener('paste', this.pasteHandle);
			},

			blurHandle() {
				if (this.active) return;
				this.focusState = false;
				window.removeEventListener('click', this.blurHandle, true);
				document.removeEventListener('paste', this.pasteHandle);
			},

			pasteHandle(e) {
				if (!this.focusState) return;
				e.preventDefault();
				const items = (e.clipboardData || window.clipboardData).items;
				if (!items) return;

				let files = [];
				for (let item of items) {
					if (item.kind === 'file') {
						files.push(item.getAsFile());
					}
				}

				if (files.length) {
					this.uploadHandle(files);
				}
			},
			
			removeHandle(i) {
				let data = this.parseValueData.join(',').split(',');
				data.splice(i, 1);
				this.set(this.multiple ? data : data.join(','));
				this.changeHandle();
			},

			uploadHandle(files) {
				this.cFormItemStore && this.cFormItemStore.commit('warnState', false);

				if (this.upperLimit && this.multiple) {
					this.$message({
						message: this.$t('_t.upload.message.limit', {limit: this.multiple})
					});
					return;
				}

				this.folder && this.uploadConfig({
					folder: this.folder
				});
				
				this.$upload({
					files,
					type: this.type,
					size: this.size,
					count: this.multiple ? typeof this.multiple != 'boolean' ? parseInt(this.multiple) - this.parseValueData.length : Infinity : 1,
					loading: true,
					success: data => {
						if (this._events.upload) {
							this.$emit('upload', data);
							return;
						}
						if (!this.multiple) {
							if (Array.isArray(data)) {
								data = data[0];
							}
							this.set(data.path);
						} else {
							this.set(this.parseValueData.concat(Array.from(data, item => item.path)));
						}
						this.changeHandle();
					}
				});
			},

			changeHandle() {
				this.$emit('change', this.get());
				this.cFormStore && this.cFormStore.commit('editState', true);
				this.input && this.$nextTick(this.updatePosition);
			},
			
			updatePosition() {
				let rect = this.$el.getBoundingClientRect();
				let width = this.$refs.window.offsetWidth;
				let height = this.$refs.window.offsetHeight;
				let right = window.innerWidth - 20 - rect.left < width;
				let up = window.innerHeight - rect.bottom < height;
				this.windowPosition = {
					left: (right ? rect.right - width : rect.left) + 'px',
					top: window.scrollY + (up ? rect.top - height : rect.top + rect.height) + 'px'
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-poly-upload {
		&-input {
			position: relative;
			box-sizing: border-box;
			min-height: 38px;
			border: 1px solid var(--unit-border);
			padding-left: 4px;
			background: #fff;
			cursor: pointer;
			transition: border .1s ease;

			&:hover,
			&.z-active {
				border-color: var(--unit-active-border);
				background: #FEFEFE;
			}

			&[warn] {
				border-color: var(--unit-warn) !important;
			}

			&-list {
				padding: 4px 0;

				>>> .c-file-media {
					display: inline-block;
					vertical-align: top;
					box-sizing: border-box;
					width: 28px;
					height: 28px;
					margin-right: 4px;
					border-color: #ddd;
					background: #F5F5F5;
				}
			}

			&-icon {
				min-width: 28px;
				font-size: 16px;
				text-align: center;
				color: #999;
			}
		}

		&-window {
			z-index: 2001;
			position: fixed;
			left: 0;
			top: 0;
			width: 350px;
			border-radius: 4px;
			padding: 12px;
			background: #fff;
			box-shadow: 0 0 8px 0 rgba(0,0,0,.15);
		}

		&-main {
			gap: 6px;
			box-sizing: border-box;
			height: 38px;
			border: 1px dashed var(--unit-border);
			padding: 0 8px;
			font-size: 13px;
			white-space: nowrap;
			color: #999;
			background: #F9F9F9;
			cursor: pointer;
			transition: border .1s ease;

			&:hover,
			&.z-active {
				border-color: var(--unit-active-border);
				background: #FEFEFE;
			}

			&[warn] {
				border-color: var(--unit-warn) !important;
			}
		}

		&-list {
			max-height: 150px;
			margin-top: 5px;
			overflow: auto;
			background: #F9F9F9;

			li {
				a {
					min-width: 40px;
					height: 44px;
					line-height: 44px;
					font-size: 16px;
					text-align: center;
					color: #f55;
					opacity: .8;

					&:hover {
						color: #f00;
						opacity: 1;
					}
				}
			}
		}
	}
</style>
